<template>
  <div id="app">
    <nprogress-container></nprogress-container>
    <nav-bar></nav-bar>
    <status-bar v-show="false"></status-bar>
    <main-content></main-content>
    <footer-bar></footer-bar>
    <div class="pageloader" :class="{ 'is-active': isLoading }" v-if="shouldShowPageLoader">
      <span class="title">
        Loading {{ pageName }}
      </span>
    </div>
  </div>
</template>

<script>
import 'bulma-extensions/dist/js/bulma-extensions.min.js'
import 'bulma-extensions/bulma-pageloader/dist/css/bulma-pageloader.min.css'
import 'bulma-extensions/bulma-timeline/dist/css/bulma-timeline.min.css'

import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import { NavBar, MainContent, FooterBar, StatusBar } from 'components/layout/'

export default {
  components: {
    'nav-bar': NavBar,
    'status-bar': StatusBar,
    'main-content': MainContent,
    'footer-bar': FooterBar,
    'nprogress-container': NprogressContainer
  },
  computed: {
    isLoading () {
      return this.$store.state.loading
    },
    shouldShowPageLoader () {
      const path = this.$route.path
      const enablePageList = ['/contract', '/tx']
      for (let i in enablePageList) {
        if (path.startsWith(enablePageList[i])) {
          return true
        }
      }

      return false
    },
    pageName () {
      let path = this.$route.path
      if (path.startsWith('/tx')) {
        return 'Transaction'
      } else if (path.startsWith('/contract')) {
        return 'Contract'
      }
      return 'Page'
    }
  }
}
</script>

<style lang="scss">
/*@import url('https://fonts.googleapis.com/css?family=Roboto+Mono|Dancing+Script');*/
/* @import url('http://fonts.font.im/css?family=Roboto+Mono|Dancing+Script'); */

@import '~animate.css';
.animated {
  animation-duration: .377s;
}

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: hsl(171, 100%, 41%);
$primary-invert: findColorInvert($primary);

$success: green;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert)
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// font

body {
  font-family: ($family-sans-serif, "Microsoft Yahei","微软雅黑", STXihei, "华文细黑")!important;
}

/*
code, pre {
  font-family: 'Roboto Mono', monospace !important;
}
*/

$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

// global custom style
.has-shadow {
  box-shadow: 0 2px 3px hsla(0,0%,4%,.1);
}

h2, h4 {
  font-weight: 400!important;
}

table {
  width: 100%;
}

th {
  text-align: center!important;
  background-color: hsl(0, 0%, 86%);
  border: none!important;

  padding: 0.8rem 0.75rem!important;
}

tbody {
  td {
    border: 1px solid #dbdbdb;
    border-width: 0 0 1px;
    border-bottom-width: 1px!important;
  }
}

td {
  max-width: 0;
  overflow: hidden;
  word-break: break-word;
  text-align: center!important;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  padding: 0.8rem 0.75rem!important;
}

td {
  a {
    color: $info;
  }
}

td.date {
  width: 12rem;
}

td.type {
  width: 6rem;
}

td.amount {
  width: 6rem;
}

td.account, td.hash {
  font-family: monospace;
  text-transform: uppercase;
}

code {
  word-wrap: break-word!important;
}

// Nprogress-bar
.nprogress-container {
  position: fixed !important;
  width: 100%;
  height: 50px;
  z-index: 2048;
  pointer-events: none;

  #nprogress {
    $color: $primary;

    .bar {
      background: $color;
    }
    .peg {
      box-shadow: 0 0 10px $color, 0 0 5px $color;
    }

    .spinner {
      visibility: collapse;
    }

    .spinner-icon {
      border-top-color: $color;
      border-left-color: $color;
    }
  }
}

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// customer is god
.navbar {
  min-height: 3.75rem;
  border-bottom: none!important;
}

.navbar-brand {
  min-height: 3.75rem;
}

.navbar-burger {
  width: 3.75rem;
  min-height: 3.75rem;
}

</style>



// WEBPACK FOOTER //
// src/App.vue